import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import {
  mapSetActiveMenuToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { Box, Grid } from "@mui/material";
// import { Check, Delete, Edit } from "@mui/icons-material";
import TableList from "./CustomTool/TableList";
import CtCmb from "./CustomTool/CtCmb";
import CtBtn from "./CustomTool/CtBtn";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import CtCheckBox from "./CustomTool/CtCheckBox";
import { apiURL } from "./API";
import { Receipt } from "@mui/icons-material";
import { getRowData } from "../SystemUtility/SystemUtility";

class PaymentPrint extends Component {
  state = {
    CheckedInvoiceList: [],
    formData: {
      chkPrintSignatureAndStamp: 0,
    },
  };

  //#region Component
  componentDidMount() {
    document.title = "RA : Payment Print";
    this.props.setActiveMenu("PaymentPrint");
  }
  //#endregion Component

  //#region Handles
  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {});
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleOnChkChange = (e) => {
    // console.log("e.target.checked", e.target.checked);
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.checked,
      },
    });
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };
  //#endregion Handles

  //#region Function

  setSalesInvoiceSelection = (CheckedInvoiceList) => {
    this.setState({
      CheckedInvoiceList,
    });
  };

  openPrint = () => {
    this.openPaymentPrint(
      this.props.bint_acid,
      this.props.bint_acyear,
      this.props.bint_expensesrno
    );
  };

  openPaymentPrint = (bint_acid, bint_acyear, bint_expensesrno) => {
    this.props.notifyProcessing();
    let PrintFormat = getRowData(
      this.props.GeneralSettingList,
      "vac_key",
      "Print Format"
    );
    let Op = "";
    if (PrintFormat["vac_value"] === "Gujarati Data") {
      Op = "VoucherPrint_HTML";
    } else {
      Op = "VoucherPrint";
    }

    let reqData = [
      { name: "Op", value: Op },
      { name: "bint_acyear", value: bint_acyear },
      { name: "bint_acid", value: bint_acid },
      { name: "bint_expensesrno", value: bint_expensesrno },
      {
        name: "bolPrintSingatureStamp",
        value: this.state.formData.chkPrintSignatureAndStamp ? 1 : 0,
      },
    ];

    // Create a query string from the request data
    let queryString = reqData
      .map(
        (data) =>
          encodeURIComponent(data.name) + "=" + encodeURIComponent(data.value)
      )
      .join("&");

    // Set the URL of the popup window
    let popupURL = apiURL + "expenseentrydetail.php?" + queryString;

    // Open the popup window
    window.open(
      popupURL,
      "PaymentList",
      "width=" +
        window.screen.availWidth +
        ",height=" +
        window.screen.availHeight
    );

    this.props.updateProcessing("success", "PDF Open in popup.");
  };

  //#endregion

  render() {
    return (
      <div>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          marginTop={0}
          marginBottom={0}
        >
          <Grid item>
            <CtCheckBox
              id="chkPrintSignatureAndStamp"
              name="chkPrintSignatureAndStamp"
              label="Print Signature and Stamp"
              checked={this.state.formData.chkPrintSignatureAndStamp}
              handleCheckChange={this.handleOnChkChange}
              // disabled={this.state.diableChk}
              // onKeyDown={this.props.onKeyDown}
              // nextCtrlID="cmbInvoiceFormat"
            ></CtCheckBox>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          marginTop={0}
          marginBottom={0}
        >
          <Grid item>
            <CtBtn label="Print Voucher" onClick={this.openPrint} />
          </Grid>
        </Grid>

        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </div>
    );
  }
}

export default withRouter(
  connect(
    mapStatetoProps,
    mapSetActiveMenuToProps
  )(HoCtToastContainer(PaymentPrint))
);
